import Features from "../components/Home/Features";
import HearFromCustomer from "../components/Home/HearFromCustomer";
import HeroPage from "../components/Home/HeroPage";
import StatsRibbon from "../components/Home/StatsRibbon";
// import Stats from "../components/Home/Stats";
import HowItWorks from "../components/Home/HowItWorks";
import UseCases from "../components/Home/UseCases";
import EnterpriseReady from "../components/Home/EnterpriseReady";
import ResourcesSection from "../components/Resources/HeroSection";
import JoinUs from "../components/JoinUs";

const HomePage = () => {
  return (
    <main className="snap-y snap-mandatory overflow-y-scroll">
      <div className="overflow-none relative min-h-screen w-screen">
        <div className="gradient-bg absolute left-0 top-[40%] h-1/2 w-full md:left-1/2 md:top-[45%] md:h-[60%] md:w-[80%] md:-translate-x-1/2 md:-translate-y-1/2" />
        <HeroPage />
      </div>
      <StatsRibbon />
      <HowItWorks />
      <UseCases />
      {/* <Features /> */}
      <EnterpriseReady />
      <HearFromCustomer />
      <ResourcesSection from="home" />
    </main>
  );
};

export default HomePage;
